import { z } from 'zod';
import { SourceSystem } from '../enums.js';
import { IsoDateTime, UuidString } from '../primitives.js';

/** EvidenceRef — ссылка на исходный документ / строку регистра для traceability. */
export const EvidenceRef = z.object({
  id: UuidString,
  entity_id: UuidString.optional(), // BE handler не всегда возвращает; tolerant до S-FIX-6 audit.
  run_id: UuidString.nullable(),
  /**
   * Lenient string — BE возвращает 'invoice', 'payment' и другие domain-specific kinds,
   * не только UI-canonical values. Validation на FE — informational, не behavior-critical.
   */
  kind: z.string(),
  source_system: SourceSystem,
  /** Алиас для `source_system` — используется UI для коротких бейджей. */
  source: SourceSystem.optional(),
  source_document_id: z.string().nullable(),
  /** Алиас для `source_document_id` — упрощённый UI-контракт. */
  document_id: z.string().nullable().optional(),
  pointer: z.record(z.unknown()), // flexible — row_id, cell, sheet, line_no…
  label: z.string(),
  hash: z.string().nullable(),
  fetched_at: IsoDateTime.optional(),
  created_at: IsoDateTime,
});
export type EvidenceRef = z.infer<typeof EvidenceRef>;
